<template>
	<countdown :value="progress" />
</template>

<script>
import Countdown from '@/components/shared/countdown';
import { isNil } from 'ramda';

export default {
	name: 'CountdownTimer',
	components: { Countdown },
	data() {
		return {
			progress: 100,
			$interval: null,
		};
	},
	methods: {
		startCountdown() {
			if (!isNil(this.$interval)) {
				this.resetCountdown();
			}
			const timer = () => {
				if (this.progress < 1) {
					this.$emit('countdownFinished');
					this.resetCountdown();
				} else {
					this.progress -= 20;
				}
			};
			timer();
			this.$interval = setInterval(timer, 1000);
		},
		resetCountdown() {
			clearInterval(this.$interval);
			this.progress = 100;
		},
	},
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/shared/components/business/CountdownTimer.vue